import { render } from "./buscador.vue?vue&type=template&id=279c2c6c"
import script from "./buscador.vue?vue&type=script&lang=js"
export * from "./buscador.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__